<template>
    <div>
        <h5 class="heading-1">
            <span>PESQUISA</span>
        </h5>
        <b-row>
            <b-col>
                <b-form-group>
                    <label class="required">
                        <strong
                            >{{pergunta1}}</strong
                        >
                    </label>
                    <b-form-radio-group v-model="resposta01">
                        <b-form-radio
                            v-for="(resposta, index) in respostas"
                            :key="resposta.idTipoResposta"
                            :value="resposta.idTipoResposta"
                            class="form-check-inline"
                        >
                            <strong>
                                <span :class="estiloResposta[index]">{{ resposta.vcDescTipoResposta.toUpperCase() }}</span>
                            </strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>  
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group>
                    <label class="required">
                        <strong
                            >{{pergunta2}}</strong
                        >
                    </label>
                    <b-form-radio-group v-model="resposta02">
                        <b-form-radio
                            v-for="(resposta, index) in respostas"
                            :key="resposta.idTipoResposta"
                            :value="resposta.idTipoResposta"
                            class="form-check-inline"
                        >
                            <strong>
                                <span :class="estiloResposta[index]">{{ resposta.vcDescTipoResposta.toUpperCase() }}</span>
                            </strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-button
                    variant="danger"
                    v-if="!informarProblema"
                    @click="informarProblema = true"
                    >Realizar comentário</b-button
                >
                <b-form-group v-if="informarProblema">
                    <label>
                        <strong>Problema</strong>
                    </label>
                    <b-form-textarea
                        v-model="problema"
                        :rows="5"
                        :disabled="false"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import DespesasServicos from './DespesasServicos'
export default {
    emits: ['input'],
    props: {
        value: {
        type: Object,
            default: () => ({
                avaliacoes: []
            })
        },
        despesa:
        {
            type: Object,
        }
    },

    data() {
        return {
            resposta01: '',
            resposta02: '',
            problema: '',
            sequencial: '',
            informarProblema: false,
            respostas: [],
            perguntas: [],
            estiloResposta: [
                "",
                "text-danger",
                "text-warning",
                "text-success",
                "text-primary"  
            ]
        }
    },

    created() {
        this.obterRespostas()
        this.obterPerguntas()
    },

    watch: {
        resposta01() {
            this.atualizar()
        },

        resposta02() {
            this.atualizar()
        },

        problema() {
            this.atualizar()
        }
    },

    computed: {
        pergunta1() {
            if (this.perguntas == null || this.perguntas.length < 1) {
                return "Pergunta 1"
            }
            return this.perguntas[0].vcDescPerguntaAvaliacaoDespesaGeral
        },
        pergunta2() {
            if (this.perguntas == null || this.perguntas.length < 2) {
                return "Pergunta 2"
            }
            return this.perguntas[1].vcDescPerguntaAvaliacaoDespesaGeral
        }
    },

    methods: {
        atualizar() {
            let retorno = {
                avaliacoes: [
                    {
                        perguntaId: this.perguntas[0].idPerguntaAvaliacaoDespesaGeral,
                        respostaId: this.resposta01,
                        problema: this.problema

                    },
                    {
                        perguntaId: this.perguntas[1].idPerguntaAvaliacaoDespesaGeral,
                        respostaId: this.resposta02,
                        problema: this.problema
                    }
                ]
            };
            this.$emit('atualizarAvaliacao', retorno);
        },

        obterRespostas() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterTiposRespostas().then(response => {
                if (response) {
                    if (response.success) {
                        this.respostas = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        obterPerguntas() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterPerguntas().then(response => {
                if (response) {
                    if (response.success) {
                        this.perguntas = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
